// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ent-settings .page-data-section__heading {\n  padding: 20px 20px 0;\n}\n.ent-settings .page-data-section__title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.ent-settings .title-note {\n  margin-left: auto;\n  color: #f93;\n  font-weight: normal;\n  font-size: 12px;\n}\n@media (max-width: 1024px) {\n.ent-settings .page-data-section__heading {\n    padding: 15px 15px 0;\n}\n.ent-settings .title-note {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
